/*
 * @Author: AnNa
 * @Date: 2020-10-16 14:48:42
 * @LastEditors: AnNa
 * @LastEditTime: 2021-08-10 17:00:46
 * @Description:
 */
// import config from '@/config/app.config'
// import axios from 'axios'
const OSS = require('ali-oss')
const config = {
  ossConfig: {
    region: 'oss-accelerate',
    bucket: 'nianchu-transfer-data',
    accessKeyId: 'LTAI4Fe3x79RXbY9CxwzdWwK',
    accessKeySecret: 'H62ldRqn4fbqCf4gvfREdASOV2Nsjl'
  }
}

let modal

const soup_ = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
const UID = () => {
  var length = 32
  var soupLength = soup_.length
  var id = []
  for (var i = 0; i < length; i++) {
    id[i] = soup_.charAt(Math.random() * soupLength)
  }
  return id.join('')
}

const progress = (p, _checkpoint) => {
  console.log(p) // Object的上传进度。
  console.log(_checkpoint) // 分片上传的断点信息。
  checkpoint = _checkpoint
}

let checkpoint
/**
 * 文件上传至 oss
 * @param {*} file_re 编码后文件
 * @param {*} file 上传的源文件
 * @param {*} type 文件类型 用于设置存放目录
 */
// eslint-disable-next-line camelcase
export async function bigFileUpload (file, dir) {
  modal && modal.destroy()

  const fileName = file.name.substring(file.name.lastIndexOf('.') + 1)
  const client = new OSS({
    region: config.ossConfig.region,
    accessKeyId: config.ossConfig.accessKeyId,
    accessKeySecret: config.ossConfig.accessKeySecret,
    bucket: config.ossConfig.bucket
  })
  // try {
  // object-name可以定义为文件名（例如file.txt）或目录（例如abc/test/file.txt）的形式，实现将文件上传至Bucket根目录或Bucket下的指定目录。
  try {
    const result = await client.multipartUpload(`${dir}/${UID()}.${fileName}`, file, {
      checkpoint,
      progress,
      // meta是用户自定义的元数据，通过head接口可以获取到Object的meta数据。
      meta: {
        upload: fileName
      }
    })
    checkpoint = null
    return 'http://nianchu-transfer-data.oss-accelerate.aliyuncs.com/' + result.name
    // result.
  } catch (e) {
    console.log(e)
    // setTimeout((() => {
    // bigFileUpload(file)
    // }), 2000)
  }
}

export function readFileAsBuffer (file) {
  const reader = new FileReader()
  return new Promise((resolve, reject) => {
    reader.readAsDataURL(file)
    reader.onload = function (e) {
      const base64File = reader.result.replace(/^data:\w+\/\w+;base64,/, '')
      resolve(new OSS.Buffer(base64File, 'base64'))
    }
  })
}

export function upload (file_re, file, type) {
  const client = new OSS({
    region: config.ossConfig.region,
    // region: 'oss-cn-hongkong',
    accessKeyId: config.ossConfig.accessKeyId,
    accessKeySecret: config.ossConfig.accessKeySecret,
    bucket: config.ossConfig.bucket
    // bucket: 'nianchu-robot-yun-resource'
  })
  console.log(file)
  console.log(type)
  if (type == 'images') {
    let size = file.size
    if (size / (1024 * 1024) > 1) {
      notification.error({
        message: '图片错误',
        description: '图片文件大小不能超过1M'
      })
      return
    }
  } else if (type == 'video') {
    let size = file.size
    if (size / (1024 * 1024) > 10) {
      notification.error({
        message: '视频错误',
        description: '视频文件大小不能超过10M'
      })
      return
    }
  }
  var imgtype = file.name.substr(file.name.length - 4)
  var store = `/${type}/` + uuid() + imgtype
  return client.put(store, file_re).then(res => {
    // 这个结果应该就是url吧
    // var a = client.signatureUrl(store)
    console.log()
    return {
      data: res,
      url: res.url
    }
  })
}
/**
 * 生成唯一UUID
 */
export function uuid () {
  const s = []
  const hexDigits = '0123456789abcdef'
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-'
  var uuid = s.join('')
  return uuid
}

// } catch (e) {
//   // 捕获超时异常。
//   if (e.code === 'ConnectionTimeoutError') {
//     console.log('TimeoutError');
//     // do ConnectionTimeoutError operation
//   }
//   console.log(e);
// }

const file = 'D:/QQfile/1426764540/FileRecv/数据库.db'

// bigFileUpload(file)
